import React from 'react';
import { useSelector } from 'react-redux';

import { RootStore } from 'store/reducer';
import {
  selectAccountsByUserGroupId,
  selectAccountsList
} from 'store/accounts';
import { Button, UserBadge } from 'shared';
import { Flyover } from 'v1/components/shared';

type UserSelectorProps = {
  userGroupId?: string;
  onSelect: (id: string) => void;
};

const UserSelector = ({ userGroupId, onSelect }: UserSelectorProps) => {
  const accountsList = useSelector(selectAccountsList);
  const userGroupAccounts = useSelector((state: RootStore) =>
    userGroupId ? selectAccountsByUserGroupId(state, userGroupId) : null
  );

  const filteredAccounts =
    userGroupId && userGroupAccounts
      ? accountsList.filter(
          account => !userGroupAccounts.find(a => a.id === account.id)
        )
      : accountsList;

  return (
    <Flyover>
      <Flyover.Trigger>
        <Button icon="add" label="Add users" size="s" />
      </Flyover.Trigger>
      <Flyover.Content width="M" filterable onSelect={onSelect}>
        {filteredAccounts.map(account => (
          <Flyover.Item
            key={account.id}
            //  @ts-ignore - v1 component
            value={account.id}
            filterValue={account.displayName}
          >
            <UserBadge id={account.id} />
          </Flyover.Item>
        ))}
      </Flyover.Content>
    </Flyover>
  );
};

export default UserSelector;
